import type { ColDef } from 'ag-grid-community';

/** Header click cycle for columns opted in to absolute sorting. */
export const ABSOLUTE_SORT_SORTING_ORDER: ColDef['sortingOrder'] = [
  { type: 'default', direction: 'asc' },
  { type: 'default', direction: 'desc' },
  { type: 'absolute', direction: 'asc' },
  { type: 'absolute', direction: 'desc' },
  null,
];

export function getAbsoluteSortSortingOrder(column: {
  supportsAbsoluteSort?: boolean;
  sortingOrder?: ColDef['sortingOrder'];
}): ColDef['sortingOrder'] | undefined {
  if (column.sortingOrder != null) {
    return column.sortingOrder;
  }

  if (column.supportsAbsoluteSort) {
    return ABSOLUTE_SORT_SORTING_ORDER;
  }

  return undefined;
}
